module.exports = __webpack_public_path__ + "img/core1.8422bfdd.png";